
import { Vue, Component } from 'vue-property-decorator';
import {
    Plms,
    Authorize,
    getToken,
    Pay,
    TempPay as TempPayApi,
} from '@/service';
import {
    token,
    tokenClear,
    tokenParse,
    tokenCheck,
    encodeBase64,
    decodeBase64,
    userAgent,
    datetimeFormatter,
} from '@/assets/ts/util';

import loading from '@/components/loading.vue';
import dateTimePicker from '@/components/pui/packages/date-time-picker/src/date-time-picker.vue';

@Component({
    name: 'TempPay',
    components: {
        loading,
        dateTimePicker,
    },
})
export default class TempPay extends Vue {

    public $message!: any;
    // 车场信息
    private park: any = {};
    // 提交状态
    private showLoading: boolean = false;
    private form: any = {
        username: '',
        house_name: '',
        phone: '',
        plate: '',
        time: '',
    };

    get payMoney() {
        return +this.$route.query.money || 0;
    }

    get month() {
        return +this.$route.query.month || 0;
    }

    get endTime() {
        if (!this.form.time) {
            return '';
        }
        const start = new Date(this.form.time);
        const month = start.getMonth() + this.month;
        const end = new Date(this.form.time).setMonth(month);
        return datetimeFormatter(end, 'yyyy-MM-dd');
    }

    public init() {
        if (tokenCheck()) {
            if (this.$route.query.park_id) {
                this.getPark(+this.$route.query.park_id);
            } else {
                this.$message('车场id丢失，请联系负责人');
            }

        } else if (this.$route.query.token_sign && this.$route.query.unionid) {
            if (userAgent() === 'Wechat' && !this.$route.query.openid) {
                Authorize(encodeBase64(location.href));
            } else {
                const { unionid, token_sign } = this.$route.query;

                this.getToken(unionid, token_sign).then((data: any) => {
                    token(data.token);
                    this.init();
                }).catch((err: any) => {
                    // do nothing.
                    console.warn(err);
                });
            }
        } else {
            Authorize(encodeBase64(location.href));
        }
    }

    public getToken(unionid: any, tokenSign: any) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await getToken(unionid, tokenSign);
                resolve(data);
            } catch (err) {
                console.warn(err);
                reject(err);
            }
        });
    }

    public async getPark(parkId: number) {
        try {
            const { data } = await Plms.parkDetail({ park_id: parkId });
            this.park = data || {};
        } catch (err) {
            console.warn(err);
        }
    }

    public async pay(e: TouchEvent | MouseEvent) {
        if (e.constructor === MouseEvent
            && 'ontouchstart' in document.documentElement === true) {
            return;
        }

        if (!this.park.park_id) {
            this.$message('车场id丢失，请联系负责人');
            return;
        }

        if (!this.payMoney) {
            this.$message('缴费金额丢失，请联系负责人');
            return;
        }

        if (!this.month) {
            this.$message('缴费周期丢失，请联系负责人');
            return;
        }

        const {
            username,
            house_name,
            phone,
            plate,
            time,
        } = this.form;
        if (!username) {
            this.$message('请输入姓名');
            return;
        }
        if (!house_name) {
            this.$message('请输入房号');
            return;
        }
        if (!phone) {
            this.$message('请输入手机号');
            return;
        }
        if (!plate || plate.length < 7) {
            this.$message('请输入完整车牌');
            return;
        }
        if (!time) {
            this.$message('请输入缴费时间');
            return;
        }

        this.showLoading = true;
        try {
            await TempPayApi.infoAdd({
                username,
                house_name,
                phone,
                plate: plate.toUpperCase(),
                times: [
                    datetimeFormatter(time, 'yyyy-MM-dd'),
                    this.endTime,
                ].join('_'),
            });
            const { data } = await Pay.customMoneyWepay({
                park_id: this.park.park_id,
                money: +this.payMoney,
                remark: plate.toUpperCase(),
            });
            eval(data);
        } catch (err) {
            console.warn(err);
            this.$message(err);
        } finally {
            this.showLoading = false;
        }
    }

    private created() {
        this.init();
    }
}
